import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import {
  Link as RouterLink,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import CompletedOmnis from "../../components/Brand/Reports/CompletedOmnis";
import AllOmnisSummaryTable from "../../components/Brand/Reports/AllOmnisSummaryTable";

const DataOpsOmnisPage: React.FC<{}> = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");

  const tabs = [
    { path: "/data-ops/omnis/summary", name: "Summary" },
    { path: "/data-ops/omnis/development", name: "Development" },
  ];

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `Store Locators - ${selectedTabName}`;
  }, [selectedTabName]);

  return (
    <Box>
      <h1>Store Locators</h1>

      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>

      <Routes>
        <Route
          path="/"
          element={<Navigate to="/data-ops/omnis/summary" replace={true} />}
        />
        <Route path="summary" element={<AllOmnisSummaryTable />} />
        <Route path="development" element={<CompletedOmnis />} />
      </Routes>
    </Box>
  );
};

export default DataOpsOmnisPage;
